import { render, staticRenderFns } from "./ProductContentSection.vue?vue&type=template&id=6b51cdc6&scoped=true&"
import script from "./ProductContentSection.vue?vue&type=script&lang=js&"
export * from "./ProductContentSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentSection.vue?vue&type=style&index=0&id=6b51cdc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b51cdc6",
  null
  
)

export default component.exports